import Vue from "vue/dist/vue.esm";
import VueI18n from "vue-i18n";
import getLocale from "/utils/locale";
import CookieBanner from "./components/cookie-banner";
import store from "store";

Vue.use(VueI18n);

const init = () => {
  const container = document.querySelector(".vue-cookie-banner");

  if (!container) {
    return;
  }

  initBanner(container);
};

const initBanner = (el) => {
  new Vue({
    name: "CookieBannerInit",
    el,
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render (createElement) {
      return createElement(CookieBanner);
    }
  });
};

export default init;
